import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import React, { useEffect, useRef, useState } from "react";
import { SelectV2 } from "../../redesign-components/SelectV2/SelectV2";

export const Pagination = ({
  className,
  currentPage,
  onPageChange,
  onRowsPerPageChange,
  pageNumber,
  rowsPerPage = 0,
  showItemsPerPage = false,
  size = "md",
}) => {
  const VISIBLE_RANGE = 3;

  const getDisplayedPages = () => {
    const pages = [];
    const start = Math.max(2, currentPage);
    const end = Math.min(pageNumber - 1, currentPage + 2);

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  };
  const renderPageButton = (page) => (
    <button
      key={page}
      onClick={() => onPageChange(page)}
      className={`flex ${size === "md" ? "h-10 w-10" : "h-8 w-8"} items-center justify-center rounded-md text-sm text-gray700 ${
        currentPage === page ? "bg-gray200" : "bg-white"
      }`}
    >
      {page}
    </button>
  );

  const renderEllipsis = (key) => (
    <div
      key={key}
      className={`flex ${size === "md" ? "h-10 w-10" : "h-8 w-8"} items-center justify-center rounded-md text-sm text-gray700`}
    >
      ...
    </div>
  );

  const changePage = (direction) => {
    const nextPage =
      direction === "forward" ? currentPage + 1 : currentPage - 1;
    if (nextPage >= 1 && nextPage <= pageNumber) {
      onPageChange(nextPage);
    }
  };

  return (
    <div className={`${className} w-full flex items-center justify-between`}>
      <button
        disabled={currentPage === 1}
        onClick={() => changePage("back")}
        className={`flex ${size === "md" ? "h-9 px-4" : "h-8 px-2"} items-center gap-2 rounded-full bg-gray200 text-gray700 disabled:cursor-not-allowed disabled:opacity-50`}
      >
        <ArrowBackIcon className="w-4 h-4" /> {size === "md" ? <span className="text-sm font-semibold">Previous</span> : <></>}
      </button>

      {showItemsPerPage && onRowsPerPageChange && (
        <SelectV2
          label="Items per page"
          name="rowsPerPage"
          onChange={(_, value) => onRowsPerPageChange(value)}
          options={[10, 20, 50, 100, 250].map((val) => ({
            text: val,
            value: val,
          }))}
          value={rowsPerPage}
          width="100px"
        />
      )}

      <div className="flex gap-2">
        {renderPageButton(1)}

        {currentPage >= VISIBLE_RANGE + 1 && renderEllipsis("left")}

        {getDisplayedPages().map(renderPageButton)}

        {currentPage <= pageNumber - VISIBLE_RANGE && renderEllipsis("right")}

        {pageNumber > 1 && renderPageButton(pageNumber)}
      </div>

      {showItemsPerPage && <div className="w-[100px]" />}

      <button
        disabled={currentPage >= pageNumber}
        onClick={() => changePage("forward")}
        className={`flex ${size === "md" ? "h-9 px-4" : "h-8 px-2"} items-center gap-2 rounded-full bg-gray200 text-gray700 disabled:cursor-not-allowed disabled:opacity-50`}
      >
        {size === "md" ? <span className="text-sm font-semibold">Next</span> : <></>} <ArrowForwardIcon className="w-4 h-4" />
      </button>
    </div>
  );
};
